import type {
  FundCategory,
  FundNature,
  PowerPerformanceForms,
  PurchaseMode
} from '../../../types/mutual-fund-detail.types'

export type { PurchaseMode } from '../../../types/mutual-fund-detail.types'

export enum RecommendationVariant {
  GAINS_TAX_FREE = 'GAINS_TAX_FREE',
  LOSSES_SAVE_TAX = 'LOSSES_SAVE_TAX'
}

export interface WithdrawDetail {
  folioNumber: string
  withdrawAmount: number
  gains: number
  brokerName: string
  brokerCode: string
  brokerLogo: string
  currentValue: number
  saveTax: number
  exitLoad: number
}

export interface RebalanceSuggestion {
  isin: string
  name: string
  fundNature: FundNature
  fundCategory: FundCategory
  logo: string
  powerRank: number
  performanceRating: `${PowerPerformanceForms}`
}

export enum FundSummaryMetricKey {
  INVESTMENT = 'investment',
  XIRR = 'xirr',
  ONE_DAY_RETURNS = 'oneDayReturns',
  RETURNS = 'returns'
}

export enum FundSummaryMetricLabel {
  INVESTMENT = 'Investment',
  XIRR = 'XIRR',
  ONE_DAY_RETURNS = '1D Change',
  RETURNS = 'Returns'
}

export const FUND_SUMMARY_METRIC_LABELS: Record<FundSummaryMetricKey, string> = {
  [FundSummaryMetricKey.INVESTMENT]: FundSummaryMetricLabel.INVESTMENT,
  [FundSummaryMetricKey.XIRR]: FundSummaryMetricLabel.XIRR,
  [FundSummaryMetricKey.ONE_DAY_RETURNS]: FundSummaryMetricLabel.ONE_DAY_RETURNS,
  [FundSummaryMetricKey.RETURNS]: FundSummaryMetricLabel.RETURNS
}

export interface FundSummaryMetrics {
  currentValue?: number
  initialInvestment?: number
  xirr?: number
  oneDayReturns?: number
  oneDayReturnsValue?: number
  returns?: number
  returnsValue?: number
}

export interface TaxHarvestingRecommendationReturns {
  value: number
  percentage: number
}

export type TaxHarvestingRecommendationOneDayReturns = TaxHarvestingRecommendationReturns

export interface TaxHarvestingRecommendationResponse {
  totalWithdrawAmount: number
  isFutureTax: boolean
  saveTax: number
  withdrawDetails: WithdrawDetail[]
  directFundSuggestion: RebalanceSuggestion | null
  rebalanceSuggestions: RebalanceSuggestion[]
  isin: string
  name: string
  nature: FundNature
  category: FundCategory
  powerRating: `${PowerPerformanceForms}`
  powerRank: number
  logo: string
  isElss: boolean
  purchaseMode: PurchaseMode
  xirr: number
  investedValue: number
  currentValue: number
  returns: TaxHarvestingRecommendationReturns
  oneDayReturns: TaxHarvestingRecommendationOneDayReturns
  reinvestAmount: number
}
